import {isPlatformBrowser} from '@angular/common';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';

function _window(): any {
	// return the global native browser window object
	return window;
}

@Injectable({
	providedIn: 'root'
})
export class WindowRefService {

	public isBrowser: boolean = false;
	constructor(
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	get nativeWindow(): any {
		return _window();
	}

}
